export default "__VITE_ASSET__DFzjLxjP__"